import { Loading } from '@components/atomic/atoms';
import { ArrowRight } from '@icons';
import { addUserDisclaimer } from '@lib/api_ts/usersApi';
import { SonarLogoSmall } from '@loghi/index';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface NewBrandModalProps {}

const NewBrandModal: React.FC<NewBrandModalProps> = () => {
	const [isModalOpen, setIsModalOpen] = useState(true);
	const [doNotShowAgain, setDoNotShowAgain] = useState(false);

	const queryClient = useQueryClient();

	const doNotShowAgainNewBrandModalMutation = useMutation({
		mutationFn: () => addUserDisclaimer('new_brand_modal'),
		onSuccess: () => {
			localStorage.setItem('do_not_show_new_brand_modal', 'true');
			setIsModalOpen(false);
			queryClient.invalidateQueries({ queryKey: ['userDisclaimers'] });
		},
	});

	return (
		<Modal
			show={isModalOpen}
			onHide={() => {
				setIsModalOpen(false);
			}}
			centered
			size="lg"
			className="new_brand-modal"
		>
			<Modal.Header
				style={{
					flexDirection: 'column',
					gap: '2rem',
					padding: '1.5rem',
				}}
			>
				<SonarLogoSmall
					style={{
						width: '183px',
						height: '40px',
						fill: 'var(--np-text-primary-color)',
					}}
				/>
				<h2
					style={{
						textTransform: 'none',
						textAlign: 'center',
						marginBottom: 0,
						fontSize: '32px',
					}}
				>
					Benvenuto su Sonar, l'evoluzione di OpenRep!
				</h2>
			</Modal.Header>
			<Modal.Body
				style={{
					textAlign: 'center',
				}}
			>
				<p>
					Una piattaforma sempre più completa, integrata, efficace ed efficiente per valorizzare l'uso dei fondi pubblici come strumento di
					crescita.
				</p>
				<p>Da parte tua non è richiesta alcuna azione.</p>
				<Link
					to="#new-brand"
					className="btn custom-ghost-button"
					style={{
						textTransform: 'none',
						display: 'flex',
						gap: '0.5rem',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					scopri di più{' '}
					<ArrowRight
						style={{
							fill: 'var(--np-primary-color)',
						}}
					/>
				</Link>
			</Modal.Body>
			<Modal.Footer style={{ gap: '1rem', justifyContent: 'center' }}>
				<Button
					className="btn custom-primary-button"
					disabled={doNotShowAgainNewBrandModalMutation.isPending}
					style={{
						width: '100%',
						fontWeight: 500,
						height: '3rem',
					}}
					onClick={() => {
						if (doNotShowAgain) {
							doNotShowAgainNewBrandModalMutation.mutate();
						} else {
							setIsModalOpen(false);
						}
					}}
				>
					{doNotShowAgainNewBrandModalMutation.isPending ? (
						<>
							<Loading /> Salvando...
						</>
					) : (
						'Chiudi'
					)}
				</Button>
				<Form.Check
					type="checkbox"
					label="Non mostrare più"
					id="adv_checkbox"
					checked={doNotShowAgain}
					onChange={() => {
						setDoNotShowAgain(true);
					}}
				/>
			</Modal.Footer>
		</Modal>
	);
};

export default NewBrandModal;
